module.exports = __webpack_public_path__ + "img/pro_4.841eb583.jpg";